import { useCallback, useEffect, useRef, useState } from 'react';
import { Image } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-regular-svg-icons';
import { BindUserModal } from './BindUserModal';
import { uploadActions } from '../../../actions';
import { getFileDataAsync } from './get-file-data-async';
import { delay } from '../../../util/delay';

export function BindUserForFilesModal(props) {
    const { request, files, onClose } = props;
    const [inProgress, setInProgress] = useState(false);
    const [fileData, setFileData] = useState(null);
    const finalFilesRef = useRef();
    const currentFileIndexRef = useRef();
    const dispatch = useDispatch();

    useEffect(() => {
        if (files) {
            if (files.length) {
                finalFilesRef.current = [];
                currentFileIndexRef.current = 0;
                setInProgress(true);
                getFileDataAsync(files[currentFileIndexRef.current].file).then((fileData) => {
                    setFileData(fileData);
                    setInProgress(false);
                });
            } else {
                setFileData(null);
                onClose();
            }
        }
    }, [files, onClose]);

    const handleBindUserClick = useCallback(
        async (userId) => {
            if (!files) {
                return;
            }
            const i = currentFileIndexRef.current;
            finalFilesRef.current.push({
                file: files[i].file,
                fileType: files[i].fileType,
                userId,
            });
            if (i + 1 === files.length) {
                finalFilesRef.current.forEach((file) => {
                    dispatch(
                        uploadActions.addFile({
                            requestId: request.id,
                            fileTypeId: file.fileType.id,
                            file: file.file,
                            userId: file.userId || null,
                        })
                    );
                });
                setFileData(null);
                onClose();
            } else {
                currentFileIndexRef.current++;
                setInProgress(true);
                const fileData = await getFileDataAsync(files[currentFileIndexRef.current].file);
                setFileData(null);
                setInProgress(false);
                await delay(200);
                setFileData(fileData);
            }
        },
        [files, dispatch, request, onClose]
    );

    const handleCancelClick = useCallback(() => {
        setFileData(null);
        onClose();
    }, [onClose]);

    const showModal = files && fileData != null;

    return (
        <BindUserModal
            request={request}
            show={showModal}
            userId=""
            inProgress={inProgress}
            onCancel={handleCancelClick}
            onBind={handleBindUserClick}
        >
            {fileData && (
                <div className="mb-3 d-flex">
                    <div className="mr-3">
                        {fileData.imageUrl ? (
                            <Image className="border" src={fileData.imageUrl} rounded width={64} />
                        ) : (
                            <FontAwesomeIcon icon={faFile} size="2x" />
                        )}
                    </div>
                    <div>{fileData.filename}</div>
                </div>
            )}
        </BindUserModal>
    );
}
